import { createAction } from '@reduxjs/toolkit';

export const walletUpdateId = createAction('wallet/updateId');
export const walletUpdateUID = createAction('wallet/updateUID');
export const walletUpdateSID = createAction('wallet/updateSID');
export const walletUpdateIsAdded = createAction('wallet/updateIsAdded');
export const walletUpdateIsActive = createAction('wallet/updateIsActive');

export const walletStore = createAction('wallet/store');
export const walletClear = createAction('wallet/clear');

export const walletUpdateRequest = createAction('wallet/updateRequest');
export const walletUpdateError = createAction('wallet/updateError');
export const walletUpdateStore = createAction('wallet/updateStore');

export const walletUpdateItems = createAction('wallet/updateItems');

export const walletUpdateTitle = createAction('wallet/updateTitle');
export const walletUpdateTitleColor = createAction('wallet/updateTitleColor');
export const walletUpdateDescription = createAction('wallet/updateDescription');
export const walletUpdateTextAlign = createAction('wallet/updateTextAlign');
export const walletUpdateImage = createAction('wallet/updateImage');

export const walletUpdateTextColor = createAction('wallet/updateTextColor');
export const walletUpdatePadding = createAction('wallet/updatePadding');
export const walletUpdateMargin = createAction('wallet/updateMargin');
